// js/LWsystem.js

import './components/LWheader.js';
import './components/LWcontainer.js';
import './components/LWgrid.js';
import './components/LWknop.js';
import './components/LWcard.js';
import './components/LWsearch.js';
import './components/LWswiper.js';
import './components/LWmodal.js';
import './components/LWgallery.js';
import './components/LWvideo.js';
import './components/LWmagazine.js';
import './components/LWinhoud.js';
import './components/LWfullimage.js';
import './components/LWlogo.js';
import './components/LWback.js';
import './components/LWportret.js';
import './components/LWdiv.js';
import './components/LWhamburger.js';
import './components/LWoverlay.js';

// Optioneel: Je kunt hier ook je Singleton Store exporteren 
// zodat je die overal centraal kunt benaderen.
console.log('🚀 LW System: On, Fast, and Working!');